var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmvCard = function SvgEmvCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 11V8a3 3 0 0 0-3-3H6a3 3 0 0 0-3 3v8c0 .889.386 1.687 1 2.236M3 9h18M9.389 14H6.722v2.667m2.667 2.666H6.722v-2.666m0 0h2.222m9-2.667 1.778 5.333L21.5 14m-9.778 5.333V14l2 2.667 2-2.667v5.333",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgEmvCard;